import { render } from "./BasicBreadCrumb.vue?vue&type=template&id=7adf8167&scoped=true"
import script from "./BasicBreadCrumb.vue?vue&type=script&lang=js"
export * from "./BasicBreadCrumb.vue?vue&type=script&lang=js"

import "./BasicBreadCrumb.vue?vue&type=style&index=0&id=7adf8167&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7adf8167"

export default script